<bb-page-header [icon]="'paper-plane'" [title]="'PROJECTS' | translate" [filterConfig]="filterConfig"
[currentPath]="listConfiguration.activePath"></bb-page-header>

<div class="body-column">

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell class="column-thumbnail"></bb-table-header-cell>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="sourceid">{{ 'NAME' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status" class="icon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate" class="date" >{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="column-buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell class= "column-thumbnail"><span class="thumb-wrapper" [innerHTML]="row.data | thumbnail:50:30 | async"></span></bb-table-cell>
			<bb-table-cell property="id">{{ row.id }}</bb-table-cell>
			<bb-table-cell property="title" class="overflow">{{ row.data.title }}</bb-table-cell>
			<bb-table-cell property="sourceid" class="overflow">{{ row.data.name || row.data.title }}</bb-table-cell>
			<bb-table-cell property="status"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
			<bb-table-cell class="row-actions buttons">

				<a class="button" [routerLink]="['/analytics/project', row.data.id]">
					<i class="fa fa-line-chart"></i>
				</a>
				<a class="button" (click)="showPreview(row.data)">
					<i class="fa fa-eye"></i>
				</a>
				<a class="button root" [ngClass]="{disabled: !deleteRight}" (click)="deleteSingle(row)" [hasPublicationField]="'deleteProjects'">
					<i class="fa fa-trash"></i>
				</a>


			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<bb-table-pager></bb-table-pager>

</div>
